import {
  type IncidentReportIndividualSupportSessionParticipant,
  type IncidentReportIndividualSupportSessionRiskAssessment,
  type IncidentReportIndividualSupportSessionFollowUpSession,
  type IncidentReportYesNoOther,
} from "components/CriticalIncident/interfaces";
import { EMPTY_RISK_ASSESSMENT_CORE } from "../RiskAssessments/RiskAssessments.constants";

export const MAX_CHARS = 2000;
export const MAX_PARTICIPANTS = 30;
export const PARTICIPANT_NUMBER_OPTIONS = Array.from({ length: MAX_PARTICIPANTS }, (_, i) => i + 1);

export const EMPTY_PARTICIPANT: IncidentReportIndividualSupportSessionParticipant = {
  name: '',
  dateOfBirth: null,
  wasNatureOfSupportAndConfidentialityDiscussed: null,
  howIndividualPresented: '',
  interventionProvided: '',
  followUpNotes: '',
  declinedToProvideInformation: false,
  declinedReasonToProvideInformation: '',
  wasTheIndividualAtRisk: null,
  wasThereSupervisionOrConsultation: '' as IncidentReportYesNoOther,
  wasThereSupervisionOrConsultationOtherReason: '',
  supervisionDate: null,
  supervisionOrConsultationOutcome: '',
  emailAddress: '',
  phoneNumber: '',
  riskAssessment: null,
  wereThereAnyFollowUpSessions: null,
  noOfFollowUpSessions: 0,
  followUpSessions: [],
};

// AU-only (TPH-1907/1908) — seeded onto a participant the first time "Was the individual at
// risk?" flips to true; retained (not cleared) if the answer later flips back to No.
export const EMPTY_RISK_ASSESSMENT: IncidentReportIndividualSupportSessionRiskAssessment = {
  ...EMPTY_RISK_ASSESSMENT_CORE,
  wasThereSupervisionOrConsultation: '' as IncidentReportYesNoOther,
  wasThereSupervisionOrConsultationOtherReason: '',
  supervisionDate: null,
  supervisionOrConsultationOutcome: '',
};

// AU-only (TPH-1909)
export const MAX_FOLLOW_UP_SESSIONS = 4;

export const EMPTY_FOLLOW_UP_SESSION: IncidentReportIndividualSupportSessionFollowUpSession = {
  sessionDate: null,
  sessionType: '',
  presentation: '',
  risk: '',
  intervention: '',
  recommendation: '',
};

// Best-effort draft, not yet confirmed against the backend — only "1W" is confirmed by the
// sample PATCH payload; the other four codes follow the same short-code convention.
export const FOLLOW_UP_SESSION_TYPES: { value: string; labelKey: string }[] = [
  { value: 'ID', labelKey: 'follow_up_session_type_initial_day' },
  { value: 'ND', labelKey: 'follow_up_session_type_next_day' },
  { value: '1W', labelKey: 'follow_up_session_type_one_week' },
  { value: '2W', labelKey: 'follow_up_session_type_two_week' },
  { value: '1M', labelKey: 'follow_up_session_type_one_month' },
];
